import Project from "../../project/project"
import Goal from "../goal"
import ModelProxy from "../../model-proxy"

const MAX_VALUE = 100

const debug = false
// const debug = "GoalProject"

export default class GoalProject extends Goal {

    public project: Project

    constructor(data: any, useProxy = true) {
        super(data, false)

        if (data.project instanceof Project) {
            this.project = data.project
        } else {
            this.project = new Project(data.project || {})
        }

        this.targetValue    = MAX_VALUE // progress 100%

        return useProxy ? new Proxy(this, ModelProxy) : this
    }

    openGoal() {
        gd.navigation.goToProject(this.project.id)
    }

    get noEntity() {
        return !this.project.id || !gd.session.projects.get(this.project.id)?.access // project is not returned for goal or user has no access to it
    }

    get name() {
        return this.project.name
    }

    set name(value: string) {
        this.project.name = value
    }

    get icon() {
        return this.project.iconClass || 'ii5-project'
    }

    get startDate(): MomentDate | null {
        return this.project.startDate as MomentDate || null
    }

    set startDate(value: MomentDate | null) {
        const startDate = value
        let endDate

        debug && console.log(debug, 'startDate', value)

        if (startDate && (!this.endDate || startDate?.isAfter(this.endDate, 'day'))) {
            endDate = startDate.clone() as MomentDate
        }
        if (!startDate) {
            endDate = null
        }

        this.project.startDate = startDate

        if (!_.isUndefined(endDate)) {
            this.project.endDate = endDate
        }
    }

    get endDate(): MomentDate | null {
        return (this.project.endDate || this.project.deadline || null) as MomentDate | null
    }

    set endDate(value: MomentDate | null) {
        const endDate = value
        let startDate

        // if project endDate is defined and new value is null or if startDate is defined and new value is not null
        // the start/end is updated, otherwise it is deadline
        const isStartEndUpdate = (this.project.endDate && !endDate) || (this.project.startDate && endDate)

        debug && console.log(debug, 'endDate', isStartEndUpdate, value)

        if (isStartEndUpdate) {
            if (this.startDate && endDate?.isBefore(this.startDate, 'day')) {
                startDate = endDate.clone() as MomentDate
            }
            if (!endDate) {
                startDate = null
            }

            this.project.endDate = endDate

            if (!_.isUndefined(startDate)) {
                this.project.startDate = startDate
            }
        } else {
            this.project.deadline = value
        }
    }

    get userId(): ID | null {
        return null
    }

    /*get assigneeUserIds(): ID[] {
        return _.map(this.users.models, u=>u.userId)
    }*/

    get currentValue(): number {
        return this.project.progress || 0
    }

    set currentValue(value: number) {
        this.project.progress = value
    }

    get duration():number | null {
        return this.project.durationCalendar
    }

    set duration(value:number | null) {
        this.project.durationCalendar = value
    }

    get durationWorkdays():number | null {
        return this.project.durationWorkdays
    }

    set durationWorkdays(value:number | null) {
        this.project.durationWorkdays = value
    }

    get progress(): number {
        return this.project.progress || 0
    }

    get isDone(): boolean {
        return this.progress === MAX_VALUE
    }

    get health(): number {
        return this.project.health
    }

    set health(value: number) {
        this.project.health = value
    }

    applyDelta(data:any) {
        let isChanged = super.applyDelta(data, ['project'])

        if (data.project) {
            if (data.project instanceof Project) {
                this.project = data.project
            } else {
                this.project = new Project(data.project || {})
            }
            isChanged = true
        }

        return isChanged
    }

    async save(): Promise<void> {
        await super.save()

        this.project.save()
    }

    toJSON(): any {
        const json: any = super.toJSON()

        json.project    = this.project.toJSON()

        return json
    }
}
